import type { ReactNode } from "react";

interface PaperPanelProps {
  children: ReactNode;
  className?: string;
}

/**
 * PaperPanel — an ivory card bounded by a single hairline rule.
 *
 * The base surface for grouped content. No shadow heavier than a
 * hairline, no fill beyond the paper tone — the border is the whole
 * gesture. Carries the `.paper-grain` tooth so it reads as a cut sheet
 * laid on the page.
 */
export function PaperPanel({ children, className = "" }: PaperPanelProps) {
  return (
    <div
      className={`paper-grain border border-rule bg-paper-deep px-6 py-5 ${className}`}
    >
      {children}
    </div>
  );
}
